import { PayloadAction } from "@reduxjs/toolkit";

export const handleDispatchResult = async (
  res: PayloadAction<
    any,
    string,
    {
      arg: any;
      requestId: string;
      requestStatus: "fulfilled" | "rejected";
    },
    never
  >,
  onSuccess?: (payload?: any) => void | Promise<void>,
  onFailure?: (payload?: any) => void | Promise<void>
) => {
  if (res.meta.requestStatus === "fulfilled") {
    onSuccess && (await onSuccess(res.payload));
  }

  if (res.meta.requestStatus === "rejected") {
    onFailure && (await onFailure(res.payload));
  }

  return res;
};
